import React from 'react'
import { removeItemfromArray }  from '../../../functions/lists';
import Translation from '../../Translation/cont/Translation';

const MultiselectCheckboxCinemas = ({field, form, ...props}) => {
    let {clicinemas, enabledCinemaIds} = props

    if(!enabledCinemaIds){
        enabledCinemaIds = props.value
    }

    return (
        clicinemas === 'all' ? (
            <button
            {...field}
            type="button" 
            className="button"
            onClick={() => {

                let allCheckedArray = _.union(form.values['cinemasFilter'], enabledCinemaIds)

                if(form.values['cinemasFilter'].length === allCheckedArray.length) {
                    
                    form.setFieldValue('cinemasFilter', form.values['cinemasFilter'].slice(0, 1))
                    form.setFieldValue('movieRefID', '')

                    if(props.instantSubmit) {
                        props.submitFormFunc();
                    }
                } else {
                    form.setFieldValue('cinemasFilter', allCheckedArray)

                    if(props.instantSubmit) {
                        props.submitFormFunc();
                    }
                }
            }}
            >
                { form.values['cinemasFilter'] ? form.values['cinemasFilter'].length === _.union(form.values['cinemasFilter'], enabledCinemaIds).length ? (
                    <span className="text-small-regular">
                        <Translation id="cinemas_deselect_all_cinemas"/>
                    </span>
                ) : (
                    <span className="text-small-regular">
                        <Translation id="cinemas_select_all_cinemas"/>
                    </span>
                ) : (
                    <span className="text-small-regular">
                        <Translation id="cinemas_select_all_cinemas"/>
                    </span>
                )}
            </button>
        ) : 
        _.keys(clicinemas).length > 1 ? (
            <label>
                <input               
                    {...field}
                    type="checkbox"
                    checked={form.values['cinemasFilter'].includes(props.value)}
                    disabled={enabledCinemaIds && !enabledCinemaIds.includes(props.value)}
                    onChange={(e) => {
                        let cinemasArray = form.values['cinemasFilter'] ? form.values['cinemasFilter'] : []
    
                        if(form.values['cinemasFilter'].includes(props.value)) {
                            if(form.values['cinemasFilter'].length !== 1) {
                                const newArray = removeItemfromArray(form.values['cinemasFilter'], props.value)
                                if(props.movie && _.intersection(newArray, props.movie.cinemaIds).length === 0){
                                    form.setFieldValue('movieRefID', '')
                                } 
                                form.setFieldValue('cinemasFilter', removeItemfromArray(form.values['cinemasFilter'], props.value))
                            }
                        } else {
                            cinemasArray.push(props.value)
                            form.setFieldValue('cinemasFilter', cinemasArray)
                        }

                        if(props.instantSubmit) {
                            props.submitFormFunc();
                        }

                        form.handleChange(e);
                    }}
                />
                <span className="text-small-regular">
                    {props.id}
                </span>
            </label>
        ) : (
            <label className="screen-reader-text">
                <input
                    {...field}
                    type="checkbox"
                    checked={form.values['cinemasFilter'].includes(props.value)}
                    onChange={() => {
                        let cinemasArray = form.values['cinemasFilter'] ? form.values['cinemasFilter'] : []
                        if(form.values['cinemasFilter'].includes(props.value)) {
                            form.setFieldValue('cinemasFilter', removeItemfromArray(form.values['cinemasFilter'], props.value))
                        } else {
                            cinemasArray.push(props.value)
                            form.setFieldValue('cinemasFilter', cinemasArray)
                        }

                        if(props.instantSubmit) {
                            props.submitFormFunc();
                        }
                    }}
                />
                <span className="text-small-regular">
                    {props.id}
                </span>
            </label>

        )
    )
}


export default MultiselectCheckboxCinemas